import { Typography } from '@mui/material'
import { ChevronRightMinor, DiamondAlertMajor } from '@shopify/polaris-icons'
import { memo, useCallback } from 'react'
import { ActivityItem } from 'src/interfaces/activities'
import { colors } from 'src/theme'
import tw from 'twin.macro'
import dayjs from 'dayjs'

interface Props {
  item: ActivityItem
  onClick(item: ActivityItem): void
}

const ActivitiesListItemComponent = ({ item, onClick }: Props) => {
  const handleClick = useCallback(() => {
    onClick(item)
  }, [item, onClick])

  return (
    <div
      css={tw`p-3 flex border-0 border-b border-solid border-[#EDEDED] cursor-pointer items-center hover:bg-[#F6F6F6] transition`}
      onClick={handleClick}
    >
      {item.icon || <DiamondAlertMajor width={20} height={20} />}
      <div css={tw`flex-1 ml-4`}>
        <div css={tw`flex justify-between items-center mb-1`}>
          <Typography variant="h6" fontWeight={600} color={colors.SHADES_GREY_400}>
            {item.title || 'Error'}
          </Typography>
          <Typography variant="subtitle2" fontWeight={500} color={colors.SHADES_GREY_300}>
            {dayjs(item.date).format('HH:mm MM/DD/YY')}
          </Typography>
        </div>
        <div>
          <Typography variant="body2" color={colors.BASICS_BLACK}>
            {item.text}
          </Typography>
        </div>
      </div>
      <div css={tw`ml-4 flex items-center`}>
        {item.isNotification && <div css={tw`bg-[#FF1A51] w-1.5 h-1.5 rounded-[3px] mr-[7px]`} />}
        <ChevronRightMinor fill={colors.SHADES_GREY_200} width={20} />
      </div>
    </div>
  )
}

export const ActivitiesListItem = memo(ActivitiesListItemComponent)
